import { html as h, svg as m } from "../beacon-html.d/index.js";
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const u = Symbol.for(""), v = (t) => {
  if ((t == null ? void 0 : t.r) === u)
    return t == null ? void 0 : t._$litStatic$;
}, g = (t) => ({ _$litStatic$: t, r: u }), _ = (t, ...a) => ({ _$litStatic$: a.reduce((l, s, o) => l + ((e) => {
  if (e._$litStatic$ !== void 0)
    return e._$litStatic$;
  throw Error(`Value passed to 'literal' function must be a 'literal' result: ${e}. Use 'unsafeStatic' to pass non-literal values, but
            take care to ensure page security.`);
})(s) + t[o + 1], t[0]), r: u }), p = /* @__PURE__ */ new Map(), S = (t) => (a, ...l) => {
  const s = l.length;
  let o, e;
  const r = [], c = [];
  let n, i = 0, $ = !1;
  for (; i < s; ) {
    for (n = a[i]; i < s && (e = l[i], (o = v(e)) !== void 0); )
      n += o + a[++i], $ = !0;
    i !== s && c.push(e), r.push(n), i++;
  }
  if (i === s && r.push(a[s]), $) {
    const f = r.join("$$lit$$");
    (a = p.get(f)) === void 0 && (r.raw = r, p.set(f, a = r)), l = c;
  }
  return t(a, ...l);
}, b = S(h), w = S(m);
export {
  b as html,
  _ as literal,
  w as svg,
  g as unsafeStatic,
  S as withStatic
};
